import { renderEnvelope } from "@/envelope.ts";
import { renderGame } from "@/game.ts";
import { renderQuiz } from "@/quiz";
import type { TState } from "@/types";

const index = () => {
  const content = document.querySelector<HTMLDivElement>("#content")!;

  let state: TState = "quiz";

  const setState = (newState: typeof state) => {
    state = newState;
    renderState();
  };

  const renderState = () => {
    const stateRenderers: Record<TState, () => void> = {
      quiz: () => renderQuiz(content, setState),
      game: () => renderGame(content, setState),
      envelope: () => renderEnvelope(content)
    };

    stateRenderers[state]();
  };

  renderState();
};

const render: () => void = () => {
  document.querySelector<HTMLDivElement>("#app")!.innerHTML = `
    <div class="bg-pink-300 h-full grid *:row-start-1 *:col-start-1 *:row-end-1 *:col-end-1 relative">
      <h1 class="text-4xl/11 text-center h-fit font-bold mt-4 sm:mt-20 px-4">Super úžasná valentýnská pozvánka pro Haničku</h1>
      <div class="relative top-0 h-44 sm:h-72 w-full overflow-hidden z-0">   
        <img 
          src="/hanicka_2.png"
          alt="Hanicka :)"
          class="absolute inset-0 h-full w-full object-contain animate-(--animate-spin-move-1) pt-3"
        />  
      </div>
      <div class="relative bottom-0 h-44 sm:h-72 w-full overflow-hidden z-0 mt-auto"> 
        <img 
          src="/hanicka_2.png"
          alt="Hanicka :)"
          class="absolute inset-0 h-full w-full object-contain animate-(--animate-spin-move-2) pb-3"
        />
      </div>
      <div class="flex justify-between items-center my-8 z-10">
        <div class="relative w-full h-3/6 overflow-hidden">
          <img 
            src="/hanicka.png"
            alt="Hanicka :)"
            class="absolute inset-0 h-full w-full left-[-2rem] md:left-[-5rem] object-contain animate-(--animate-kiss)"
          />
        </div>
        <div class="relative w-full h-3/6 overflow-hidden">
          <img 
            src="/hanicka.png"
            alt="Hanicka :)" 
            class="absolute inset-0 h-full w-full left-[2rem] md:left-[5rem] object-contain justify-end animate-(--animate-kiss)"
          />
        </div>
      </div>
      <section id="content" class="grid place-content-center z-10 mt-45 sm:mt-0 px-2" />
    </div>
  `;
};

document.addEventListener("DOMContentLoaded", () => {
  render();
  index();
});
